export default "__VITE_PUBLIC_ASSET__63df7c25__"